import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from "./CommonModal.module.css";
import Modal from "../../framework/modal/Modal";
import Button from "../../framework/Button";
import { fetchModalConfig } from "./modalUtils";

const CommonModal = (props) => {
  const {
    type = "success", // success,info,warn,error
    showCloseIcon = true,
    onOk = () => {},
    onCancel = () => {},
    onEscape = () => {},
    onClose = () => {},
    title,
    content,
    focusContentMarker,
    okButtonText = "Confirm",
    cancelButtonText = "Cancel",
  } = props;
  const okButtonRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const listener = useCallback((event) => {
    const key = event.key;
    if (key === "enter") {
      event.preventDefault();
      return;
    }
  }, []); //stop event detection of all keys
  useEffect(() => {
    //Delay is set to prevent key down detection of other modules, especially enter key.
    setTimeout(() => {
      setOpen(true);
    }, 300);
  }, []);
  useEffect(() => {
    okButtonRef?.current?.focus();
  }, [open]);
  useEffect(() => {
    if (open) document.addEventListener("keydown", listener, false);
    return () => {
      document.removeEventListener("keydown", listener, false);
    };
  }, [listener, open]);
  return (
    <Modal
      id="common-modal"
      open={open}
      modalStyles={fetchModalConfig(type).modalStyles}
      showCloseIcon={showCloseIcon}
      // onOk={onOk}
      // onCancel={onCancel}
      onEscape={onEscape}
      onClose={onClose}
      header={
        <div className={classes["common-modal-header"]}>
          <div className={classes["common-modal-icon"]}>
            <img
              width={32}
              height={24}
              src={fetchModalConfig(type).icon}
              alt={type}
            />
          </div>
          <div className={classes["common-modal-title"]}>{title}</div>
        </div>
      }
      content={<div className={classes["common-modal-content"]}>{content}</div>}
      footer={
        <div className={classes["common-modal-footer"]}>
          <div className={classes["common-modal-footer-item"]}>
            <Button
              id="modal_cancel_button"
              ref={cancelButtonRef}
              color="lightGrey"
              label={cancelButtonText}
              onClick={onCancel}
              markers={JSON.stringify({
                up: focusContentMarker || "modal_cancel_button",
                down: "modal_cancel_button",
                right: "modal_ok_button",
                left: "modal_ok_button",
              })}
            />
          </div>
          <div className={classes["common-modal-footer-item"]}>
            <Button
              id="modal_ok_button"
              ref={okButtonRef}
              color={type}
              label={okButtonText}
              onClick={onOk}
              markers={JSON.stringify({
                up: focusContentMarker || "modal_ok_button",
                down: "modal_ok_button",
                left: "modal_cancel_button",
                right: "modal_cancel_button",
              })}
            />
          </div>
        </div>
      }
    />
  );
};

export default CommonModal;
